import React from 'react';
import NumberedPaginator from '~/components/Pagination/NumberedPaginator';
import { RailsPaging } from '~/typings/services/rails/paging';

interface Props {
  paging: RailsPaging;
}

const SeoPagination: React.FC<Props> = ({ paging }) => {
  return <NumberedPaginator paging={paging} />;
};

export default SeoPagination;
